import { FC, Dispatch, SetStateAction } from 'react';

import IProduct from 'models/product';
import { IFoodlaCategoryOption } from 'models/category';

import DebouncedTextField from 'components/inputfields/DebouncedTextField';
import { IImage } from 'components/images/ImageSorter';
import { useProductValidations } from '../validation-context/ProductValidationContext';

interface ShortTextProps {
  readOnly?: boolean;
  state: IProduct;
  setState: Dispatch<SetStateAction<IProduct>>;
  approve?: boolean;
  sortedImages: IImage[];
  coopExportProduct?: IProduct;
  rootCategory?: IFoodlaCategoryOption;
}

const ShortText: FC<ShortTextProps> = ({ state, setState, approve, readOnly = false }) => {
  const { requiredFields } = useProductValidations();
  return (
    <>
      <DebouncedTextField<IProduct>
        readOnly={readOnly}
        style={{ marginTop: 7 }}
        label="Beskriv produkten"
        multiline
        spellCheck
        disabled={state?.isMagazine}
        inputName="short_text"
        setState={setState}
        approve={approve}
        state={state}
        multilineRows={2}
        multilineMax={20}
        withLabel
        inputClassName="data-hj-allow"
        hideComponentLabel={readOnly}
        labelOptions={{
          required: !!requiredFields.short_text,
          heading: 'Produktbeskrivning',
          text: 'Tänk på att säljande utryck som ger intrycket av att en viss produkt har bättre kvalitet än andra behöver förklaras för att inte vilseleda konsumenten.',
          link: 'https://kontrollwiki.livsmedelsverket.se/artikel/36/saljande-uttryck',
        }}
      />
    </>
  );
};

export default ShortText;
